import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store/Root'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data?.data
  return respData
}

const bulkRefundUploadConfirmReq = (fileId: string) => {
  const req = {
    fileId,
  }
  const tokens = RootStore.user.session.getTokens
  const userAccessToken = RootStore.user.session.userAccessToken
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.BulkRefundUploadConfirm,
    method: 'POST',
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { bulkRefundUploadConfirmReq }
